export function getQueryStringParameters(query: string = getWindowLocation()): {
  [key: string]: string | string[];
} {
  if (!query) {
    return null;
  }

  if (query[0] === '?') {
    query = query.substr(1);
  }
  const keyVal = query.split('&');

  return keyVal.reduce((params, param) => {
    const [key, value] = param.split('=');
    const nextValue = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
    if (key === 'featureFlags[]') {
      const previousFlags = params[key] ?? [];
      params[key] = [...previousFlags, nextValue];
    } else {
      params[key] = nextValue;
    }
    return params;
  }, {});
}

function getWindowLocation(): string {
  return window.location.search;
}
